export const attendanceValues = {
  ATTENDED: 'attended',
  LAST_MIN_CANCEL: 'last_minute_cancellation',
  NO_SHOW: 'no_show',
  INELIGIBLE: 'clientIneligible',
}

/**
 * These are the reasons for a closing a session that did not happen
 * @param {string} clientName
 */
export const changeReasons = (clientName: string, isProviderEngageDA: boolean = false) => {
  if (isProviderEngageDA) {
    return [
      { text: `${clientName} did not show up`, value: 'clientInitiatedLate' },
      { text: `${clientName} canceled the session`, value: 'clientCancel' },
      { text: 'I was unable to attend this session', value: 'providerInitiated' },
      { text: `${clientName} transitioned from my care`, value: 'clientTransition' },
      { text: 'Other', value: 'other' },
    ]
  }

  return [
    { text: `${clientName} did not show up`, value: 'clientInitiatedLate' },
    { text: `Technical issues (for provider or client)`, value: 'technicalIssues' },
    { text: 'I was unable to attend this session', value: 'providerInitiated' },
    {
      text: `${clientName} transitioned from my care and session did not meet guidelines for an attended session`,
      value: 'clientTransition',
    },
    { text: `${clientName} canceled this session`, value: 'clientCancel' },
  ]
}

export const providerUnableToAttendReasons = () => [
  {
    text: `Rescheduled within 24 Hours: I rescheduled this session within 24 hours of the session start time`,
    value: 'providerUnableToAttendReasonRescheduledWithin24hours',
  },
  {
    text: 'Planned time off: I had planned time off that was submitted through Workday for manager/ supervisor approval',
    value: 'providerUnableToAttendReasonPlannedAndApproved',
  },
  {
    text: 'Unplanned time off: I had unplanned time off that I have submitted through Workday for manager/supervisor approval',
    value: 'providerUnableToAttendReasonUnplannedAndSubmittedForApproval',
  },
  {
    text: 'Leave of Absence: I was on a leave of absence that the Leaves & Accommodations Team has approved',
    value: 'providerUnableToAttendReasonAbsenceApprovedByLeavesAndAccomodationsTeam',
  },
  {
    text: 'Severe weather: I experienced a severe weather emergency',
    value: 'providerUnableToAttendReasonSevereWeather',
  },
  {
    text: 'Client emergency: Another client had a time-sensitive clinical emergency',
    value: 'providerUnableToAttendReasonOtherClientEmergency',
  },
  {
    text: 'Other: There was another reason which I will describe below',
    value: 'providerUnableToAttendReasonOtherReason',
  },
]

export const technicalIssuesCancelSelections = (clientName: string) => [
  {
    text: `Client login: ${clientName} experienced login issues that prevented them from joining the session`,
    value: 'clientLogin',
  },
  {
    text: 'Provider login: I experienced login issues that prevented me from joining the session',
    value: 'providerLogin',
  },
  { text: 'Platform outage', value: 'platformOutage' },
  { text: 'Client internet and/or power outage', value: 'clientOutage' },
  {
    text: `Client out of state: ${clientName} joined from a state I am not licensed in (for therapists/physicians) or from a country I am not permitted to coach (for coaches)`,
    value: 'clientOutOfState',
  },
  {
    text: 'Timezone mismatch: Client / provider have different session start times due to time zone differences not accurately reflected in platform',
    value: 'timezoneMismatch',
  },
  { text: 'None of the above (provide more details in the following question)', value: 'otherTechnicalIssue' },
]

// these are the options for whether a client gave a notice within 24 hrs
export const changeNotices = (isProviderEngageDA: boolean = false) => {
  if (isProviderEngageDA) {
    return [
      { text: 'Non late cancel: Client canceled with sufficient notice', value: 'clientInitiated' },
      { text: 'Late cancel: Client canceled with insufficient notice', value: 'clientInitiatedLate' },
    ]
  }

  return [
    { text: `Non-late cancel: Client canceled with >24 hours notice`, value: 'clientInitiated' },
    { text: `Late cancel: Client canceled with < 24 hours notice; no emergency`, value: 'clientInitiatedLate' },
    {
      text: `Emergency late cancel: Client canceled with <24 hours notice due to a personal / family / medical emergency (e.g. a trip to the ER`,
      value: 'medicalEmergency',
    },
  ]
}

export const diagnoses = [
  { label: 'ADHD', value: 'adhd' },
  { label: 'Anxiety', value: 'anxiety' },
  { label: 'Behavioral Problems', value: 'behavioral_problems' },
  { label: 'Bipolar Disorder', value: 'bipolar_disorder' },
  { label: 'Chronic Pain', value: 'chronic_pain' },
  { label: 'Depression/Sadness', value: 'depression_sadness' },
  { label: 'Eating Disorder', value: 'eating_disorder' },
  { label: 'Grief', value: 'grief' },
  { label: 'OCD', value: 'ocd' },
  { label: 'Panic', value: 'panic' },
  { label: 'Parenting/Child Behavior Issues', value: 'parenting_child_behavior_issues' },
  { label: 'Relationship Issues', value: 'relationship_issues' },
  { label: 'Stress', value: 'stress' },
  { label: 'Sleep Issues', value: 'sleep_issues' },
  { label: 'Substance Abuse', value: 'substance_abuse' },
  { label: 'Trauma', value: 'trauma' },
  { label: 'Other', value: 'other' },
]
